import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/account/')({
  component: AccountIndex,
})

/**
 * Account home — there's no shared state worth showing on its own; redirect
 * to the profile tab so the URL is always one of the canonical sub-routes.
 */
function AccountIndex() {
  return <Navigate to="/account/profile" replace />
}
